<template lang="pug">
#holdings_stats
  .modal(:class="{'is-active': modal_visible}")
    .modal-background(@click="modal_visible = false")
    .modal-content.has-text-centered(style='width: 60%; max-height: calc(100vh - 80px);' @click="modal_visible = false")
      img(v-if="modal_visible == 'countries'", :src="chartUrl(stats.by_countries, 'Top Countries', 15, '550x999', colors2)")
      img(v-if="modal_visible == 'sectors'", :src="chartUrl(stats.by_sectors, 'Top Sectors', 15, '600x999', colors1)")

  .box
    .columns.has-text-centered
      .column
        .subtitle.is-5 Breakdown by Countries
        img(@click="showModal('countries')", :src="chartUrl(stats.by_countries, '', 10, '700x300', colors2)" title='Click to view more')
        p.help click to view more
        slot(name="countries_filter")
      .column
        .subtitle.is-5 Breakdown by Sectors
        div(v-if='all_countries.length == 1')
          img(@click="showModal('sectors')", :src="chartUrl(stats.by_sectors, '', 10, '900x300', colors1)" title='Click to view more')
        div(v-else)
          img(@click="showModal('sectors')", :src="chartUrl(stats.by_sectors, '', 10, '700x300', colors1)" title='Click to view more')
        p.help click to view more
        slot(name="sectors_filter")
    .columns: .column
      slot(name="sample_filters")
</template>


<script>
export default {
  name: 'holdings_stats',
  props: ['holdings', 'all_countries'],
  data() {
    return {
      colors1: 'ED4A7B|5899DA|6C8893|E8743B|2F6497|19A979|13A4B4|BF399E|EE6868|525DF4|945ECF',
      colors2: _.shuffle('ED4A7B|5899DA|6C8893|E8743B|2F6497|19A979|13A4B4|BF399E|EE6868|525DF4|945ECF'.split('|')).join('|'),
      modal_visible: false
    }
  },
  computed: {
    stats() {
      const res = {
        sum: this.holdings.map(stock => stock.owned).reduce((a, b) => a + b, 0),
        by_sectors: _.mapValues(_.groupBy(this.holdings, 'sector'), (ar => _.round(_.sumBy(ar, 'owned')))),
        by_countries: _.mapValues(_.groupBy(this.holdings, 'raw_country'), (ar => _.round(_.sumBy(ar, 'owned')))),
      }
      return res
    },
  },
  methods: {
    showModal(subtype) {
      mixpanel.track('viewed chart', { subtype })
      this.modal_visible = subtype
    },
    prepareTemplate() {
      let string = 'https://image-charts.com/chart?chxt=x,y&cht=bhg'
      string += '&chls=1&chds=a&chxs=0N*cUSD0s*'
      // string += '&chf=bg,s,f0f2f4' // background
      string += '&chtt=<%= title %>'
      string += '&chd=t:<%= values %>'
      string += '&chxl=1:|<%= labels %>'
      string += '&chco=<%= colors %>'
      string += '&chs=<%= size %>'
      return _.template(string)
    },
    prepareStats(stats, limit) {
      stats = _.take(_.sortBy(_.toPairs(stats), (ar => -ar[1])), limit)
      return {
        values: _.map(stats, (ar => ar[1])).join(','),
        labels: _.reverse(_.map(stats, (ar => `${_.replace(ar[0], '&', '')} - ${Vue.options.filters.rounded_currency(ar[1])}`))).join('|'),
      }
    },
    chartUrl(stats, title, limit, size, colors) {
      const { values, labels } = this.prepareStats(stats, limit)
      return this.prepareTemplate()({
        title,
        values,
        labels,
        colors,
        size
      }).replace('&chtt=&', '&')
    },
  },
}
</script>

<style lang="sass">
#holdings_stats
  margin-bottom: 1.5rem
  .subtitle.is-5
    margin-bottom: 0.3rem
  p.help
    margin-top: -1rem
    margin-bottom: 1rem
  img
    border: 1px solid white
    border-radius: 10px
    padding: 1em 1em 0em 0em
    background-color: white
    &:hover
      border: 1px solid lightgrey
      cursor: pointer
@media screen and (max-width: 600px)
  #holdings_stats
    .modal-content
      width: 90% !important
    .box
      padding: 1rem 0.25rem
</style>
